import React, { Component } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  Row,
  Tab,
  Tabs,
  Spinner,
} from "react-bootstrap";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import configData from "../../config.json";
import CrossTeamCheck from "../CrossTeamCheck";

class DeploymentRequestpage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      employees: [],
      deploymentprojects: [],
      frontendFilteredProjects: [],
      backendFilteredProjects: [],
      tablesFilteredProjects: [],
      userstoriestable: [],
      environmentmaster: [],
      Deploymentactiontypemaster: [],
      Testcaseprioritymaster: [],
      activeTab: "frontend",
      frontendEnvironment: "",
      frontendProject: "",
      frontendUserStory: "",
      frontendCode: "",
      frontendNpmPackages: "",
      frontendNpmPackagesList: [],
      frontendSelectFiles: "",
      frontendMovedFiles: "",
      frontendFileList: [],
      frontendTree: [],
      frontendFileSearch: "",
      expandedFolders: {},
      frontendCheckedFiles: {},
      frontendMovedChecked: {},
      frontendDoneFiles: "",
      frontendEmployee: "",
      frontendRemarks: "",
      backendEnvironment: "",
      backendProject: "",
      backendUserStory: "",
      backendCode: "",
      backendFilesChanges: "",
      backendFilesChangesList: [],
      backendFileList: [],
      backendTree: [],
      backendFileSearch: "",
      backendExpandedFolders: {},
      backendCheckedFiles: {},
      backendMovedFiles: "",
      backendMovedChecked: {},
      backendDoneFiles: "",
      backendEmployee: "",
      backendRemarks: "",
      tablesEnvironment: "",
      tablesProject: "",
      tablesUserStory: "",
      tablesCode: "",
      tablesNpmPackages: "",
      tablesEmployee: "",
      tablesRemarks: "",
      //latest list
      requestCode: "",
      projectName: "",
      sourceProject: "",
      targetEnvironment: "",
      actionType: "",
      priority: "",
      reasonForDeployment: "",
      requestedBy: "",
      assignedTo: "",
      requestDate: "",
      deploymentDate: "",
      deploymentStatus: "",
      remarks: "",
      status: "",
      approverId: "",
      approvalStatus: "",
      approvalRemarks: "",
      approvedOn: "",
      packageName: "",
      version: "",
      buildNumber: "",
      artifactPath: "",
      packageType: "",
      deploymentPackagesStatus: "",
      backendapproverId: "",
      backendapprovalStatus: "",
      backendapprovalRemarks: "",
      backendapprovedOn: "",
      backendpackageName: "",
      backendversion: "",
      backendbuildNumber: "",
      backendartifactPath: "",
      backendpackageType: "",
      backenddeploymentPackagesStatus: "",
      // GitHub repo file browser
      allRepos: [],
      frontendRepos: [],
      backendRepos: [],
      selectedFrontendRepo: "",
      selectedBackendRepo: "",
      frontendLoading: false,
      backendLoading: false,
      // Cross-team check
      showCrossTeamModal: false,
      crossTeamRequestType: "UI",
      hasCrossTeamDependency: 0,
      assignedCrossTeamDev: null,
      teamLeadApprover: "",
      managerApprover: "",
      deploymentAssignee: "",
      myTeamName: "",
      currentStage: "Draft",
      lastCreatedRequestId: null,
      // Cross-team "Raise Changes" context (set when opened from Linked Requests)
      crossTeamContext: null,
      crossTeamTargetTab: null,
      parentRequestData: null,
      parentFiles: [],
      parentPackages: [],
    };
  }
  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };
  handleTabChange = (activeTab) => {
    this.setState({ activeTab });
  };

  // Original request's file PATHS, shown inside the "Select Files List" box
  // when raising a linked request (in place of the empty GitHub-tree state).
  renderCrossTeamOriginalPaths = (boxTab) => {
    const { crossTeamContext, crossTeamTargetTab, parentFiles } = this.state;
    // Only show the original files on the tab the developer must work on.
    if (
      !crossTeamContext ||
      boxTab !== crossTeamTargetTab ||
      !parentFiles ||
      parentFiles.length === 0
    ) {
      return null;
    }
    return (
      <div>
        <div
          style={{
            color: "#0d6efd",
            fontSize: "12px",
            fontWeight: 700,
            marginBottom: "6px",
          }}
        >
          Original request files ({parentFiles.length})
        </div>
        {parentFiles.map((f, i) => (
          <div
            key={i}
            style={{
              fontSize: "12px",
              padding: "3px 4px",
              borderBottom: "1px solid #f0f0f0",
              wordBreak: "break-all",
            }}
            title={f.filePath}
          >
            {f.filePath || f.fileName || "-"}
          </div>
        ))}
      </div>
    );
  };

  // Frontend tab onChange handlers
  handleFrontendEnvironmentChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({
      frontendEnvironment: fieldValue,
      frontendProject: "",
      frontendUserStory: "",
    });
    if (fieldValue) {
      this.fetchProjectsByEnvironment(fieldValue, "frontendFilteredProjects");
    } else {
      this.setState({ frontendFilteredProjects: [] });
    }
  };

  handleFrontendProjectChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ frontendProject: fieldValue, frontendUserStory: "" });
  };

  handleFrontendUserStoryChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ frontendUserStory: fieldValue });
  };

  handleFrontendNpmPackagesChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ frontendNpmPackages: fieldValue });
  };

  handleFrontendSelectFilesChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ frontendSelectFiles: fieldValue });
  };

  handleFrontendMovedFilesChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ frontendMovedFiles: fieldValue });
  };

  // Move: take the CHECKED files from the tree and append them into
  // "Moved Files List", then clear the checkboxes.
  handleFrontendMoveFiles = () => {
    const checked = Object.keys(this.state.frontendCheckedFiles).filter(
      (p) => this.state.frontendCheckedFiles[p],
    );
    if (checked.length === 0) {
      this.showToast("Please check at least one file to move", "warning");
      return;
    }
    const existing = (this.state.frontendMovedFiles || "")
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter((line) => line.length > 0);
    const merged = [...new Set([...existing, ...checked])].join("\n");
    this.setState({ frontendMovedFiles: merged, frontendCheckedFiles: {} });
  };

  // Toggle a checkbox in the "Moved Files List"
  toggleMovedCheck = (path) => {
    this.setState((prev) => {
      const checked = { ...prev.frontendMovedChecked };
      if (checked[path]) delete checked[path];
      else checked[path] = true;
      return { frontendMovedChecked: checked };
    });
  };

  // Done: take the CHECKED moved files, push them into "Done Files List",
  // and remove them from "Moved Files List".
  handleFrontendDoneFiles = () => {
    const checked = Object.keys(this.state.frontendMovedChecked).filter(
      (p) => this.state.frontendMovedChecked[p],
    );
    if (checked.length === 0) {
      this.showToast("Please check at least one moved file", "warning");
      return;
    }

    // Update file status to "Done" in the database
    const filePaths = checked.join(",");
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("deploymentRequest_Id", this.state.deploymentRequest_Id);
    formData.append("filePaths", filePaths);
    formData.append("deploymentFilestatus", "Done");

    fetch(configData.api_url + "C_Deploymentfiles/updateStatusBulk", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((r) => r.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          const moved = (this.state.frontendMovedFiles || "")
            .split(/\r?\n/)
            .map((l) => l.trim())
            .filter((l) => l.length > 0);
          const doneExisting = (this.state.frontendDoneFiles || "")
            .split(/\r?\n/)
            .map((l) => l.trim())
            .filter((l) => l.length > 0);

          const remainingMoved = moved.filter((p) => !checked.includes(p));
          const newDone = [...new Set([...doneExisting, ...checked])];

          this.setState({
            frontendMovedFiles: remainingMoved.join("\n"),
            frontendDoneFiles: newDone.join("\n"),
            frontendMovedChecked: {},
          });
        }
      })
      .catch((e) => {
        console.error(e);
        this.showToast("Failed to update file status", "error");
      });
  };

  handleFrontendEmployeeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ frontendEmployee: fieldValue });
  };

  handleFrontendRemarksChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ frontendRemarks: fieldValue });
  };
  //deploymentrequest
  handlerequestCodeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ requestCode: fieldValue });
  };
  handleprojectNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ projectName: fieldValue, sourceProject: "" });
  };
  handlesourceProjectChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ sourceProject: fieldValue });
  };
  handletargetEnvironmentChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({
      targetEnvironment: fieldValue,
      projectName: "",
      sourceProject: "",
    });
    if (fieldValue) {
      this.fetchProjectsByEnvironment(fieldValue, "frontendFilteredProjects");
      // Auto-set assignee from environment master
      const env = this.state.environmentmaster.find(
        (em) => em.environmentName === fieldValue,
      );
      if (env && env.deploymentAssignee_Id) {
        this.setState({ assignedTo: env.deploymentAssignee_Id });
      } else {
        this.setState({ assignedTo: "" });
      }
    } else {
      this.setState({ frontendFilteredProjects: [], assignedTo: "" });
    }
  };
  handleactionTypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ actionType: fieldValue });
  };
  handlepriorityChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ priority: fieldValue });
  };
  handlereasonForDeploymentChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ reasonForDeployment: fieldValue });
  };
  handlerequestedByChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ requestedBy: fieldValue });
  };
  handleassignedToChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ assignedTo: fieldValue });
  };
  handlerequestDateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ requestDate: fieldValue });
  };
  handledeploymentDateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ deploymentDate: fieldValue });
  };
  handledeploymentStatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ deploymentStatus: fieldValue });
  };
  handleremarksChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ remarks: fieldValue });
  };
  handlestatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ status: fieldValue });
  };

  handlepackageNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ packageName: fieldValue });
  };
  handleversionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ version: fieldValue });
  };
  handlebuildNumberChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ buildNumber: fieldValue });
  };
  handleartifactPathChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ artifactPath: fieldValue });
  };
  handlepackageTypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ packageType: fieldValue });
  };
  handledeploymentPackagesStatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ deploymentPackagesStatus: fieldValue });
  };
  handleapproverIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ approverId: fieldValue });
  };
  handleapprovalStatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ approvalStatus: fieldValue });
  };
  handleapprovalRemarksChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ approvalRemarks: fieldValue });
  };
  //backend
  handleBackendactionTypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ backendactionType: fieldValue });
  };
  handleBackendpriorityChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ backendpriority: fieldValue });
  };
  handleBackendreasonForDeploymentChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ backendreasonForDeployment: fieldValue });
  };
  handleBackendrequestedByChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ backendrequestedBy: fieldValue });
  };
  handleBackendassignedToChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ backendassignedTo: fieldValue });
  };
  handleBackendrequestDateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ backendrequestDate: fieldValue });
  };
  handleBackenddeploymentDateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ backenddeploymentDate: fieldValue });
  };
  handleBackenddeploymentStatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ backenddeploymentStatus: fieldValue });
  };
  handleBackendremarksChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ backendremarks: fieldValue });
  };
  handleBackendstatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ backendstatus: fieldValue });
  };
  handleBackendversionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ backendversion: fieldValue });
  };
  handleBackendbuildNumberChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ backendbuildNumber: fieldValue });
  };
  handleBackendpackageTypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ backendpackageType: fieldValue });
  };
  handleBackenddeploymentPackagesStatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ backenddeploymentPackagesStatus: fieldValue });
  };
  handleBackendapproverIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ backendapproverId: fieldValue });
  };
  handleBackendapprovalStatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ backendapprovalStatus: fieldValue });
  };
  handleBackendapprovalRemarksChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ backendapprovalRemarks: fieldValue });
  };
  // Backend tab onChange handlers
  handleBackendEnvironmentChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({
      backendEnvironment: fieldValue,
      backendProject: "",
      backendUserStory: "",
    });
    if (fieldValue) {
      this.fetchProjectsByEnvironment(fieldValue, "backendFilteredProjects");
      const env = this.state.environmentmaster.find(
        (em) => em.environmentName === fieldValue,
      );
      if (env && env.deploymentAssignee_Id) {
        this.setState({ backendEmployee: env.deploymentAssignee_Id });
      } else {
        this.setState({ backendEmployee: "" });
      }
    } else {
      this.setState({ backendFilteredProjects: [], backendEmployee: "" });
    }
  };

  handleBackendProjectChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ backendProject: fieldValue, backendUserStory: "" });
  };

  handleBackendUserStoryChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ backendUserStory: fieldValue });
  };

  handleBackendFilesChangesChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ backendFilesChanges: fieldValue });
  };

  handleBackendEmployeeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ backendEmployee: fieldValue });
  };

  handleBackendRemarksChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ backendRemarks: fieldValue });
  };

  // Tables tab onChange handlers
  handletablesrequestCodeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tablesrequestCode: fieldValue });
  };
  handletablesprojectNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tablesprojectName: fieldValue, tablessourceProject: "" });
  };
  handletablessourceProjectChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tablessourceProject: fieldValue });
  };
  handletablestargetEnvironmentChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ targetEnvironment: fieldValue });
  };
  handletablesactionTypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tablesactionType: fieldValue });
  };
  handletablespriorityChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tablespriority: fieldValue });
  };
  handletablesreasonForDeploymentChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tablesreasonForDeployment: fieldValue });
  };
  handletablesrequestedByChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tablesrequestedBy: fieldValue });
  };
  handletablesassignedToChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tablesassignedTo: fieldValue });
  };
  handletablesrequestDateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ tablesrequestDate: fieldValue });
  };
  handletablesdeploymentDateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ tablesdeploymentDate: fieldValue });
  };
  handletablesdeploymentStatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tablesdeploymentStatus: fieldValue });
  };
  handletablesremarksChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tablesremarks: fieldValue });
  };
  handletablesstatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tablesstatus: fieldValue });
  };
  handleTablesversionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tablesversion: fieldValue });
  };
  handleTablesbuuildNumberChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tablesbuuildNumber: fieldValue });
  };
  handleTablespackageTypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tablespackageType: fieldValue });
  };
  handleTablesdeploymentPackagesStatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tablesdeploymentPackagesStatus: fieldValue });
  };
  handleTablesEnvironmentChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({
      tablesEnvironment: fieldValue,
      tablesProject: "",
      tablesUserStory: "",
    });
    if (fieldValue) {
      this.fetchProjectsByEnvironment(fieldValue, "tablesFilteredProjects");
      const env = this.state.environmentmaster.find(
        (em) => em.environmentName === fieldValue,
      );
      if (env && env.deploymentAssignee_Id) {
        this.setState({ tablesassignedTo: env.deploymentAssignee_Id });
      } else {
        this.setState({ tablesassignedTo: "" });
      }
    } else {
      this.setState({ tablesFilteredProjects: [], tablesassignedTo: "" });
    }
  };

  handleTablesProjectChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tablesProject: fieldValue, tablesUserStory: "" });
  };

  handleTablesUserStoryChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tablesUserStory: fieldValue });
  };

  handleTablesNpmPackagesChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tablesNpmPackages: fieldValue });
  };

  handleTablesEmployeeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tablesEmployee: fieldValue });
  };
  handleTablesStatusapprovalChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tablesapprovalStatus: fieldValue });
  };
  handleTablesRemarksChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ tablesRemarks: fieldValue });
  };

  addToList = (inputField, listField) => {
    const raw = this.state[inputField] || "";
    const items = raw
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter((line) => line.length > 0);
    if (items.length === 0) {
      toast.warning("Please enter a value before adding");
      return;
    }
    this.setState({
      [listField]: [...this.state[listField], ...items],
      [inputField]: "",
    });
  };

  removeFromList = (listField, index) => {
    const updated = [...this.state[listField]];
    updated.splice(index, 1);
    this.setState({ [listField]: updated });
  };

  // Build a nested folder tree from a flat list of "a/b/c.js" paths
  buildFileTree = (paths) => {
    const root = {};
    paths.forEach((p) => {
      const parts = p.split("/");
      let node = root;
      parts.forEach((part, i) => {
        const isFile = i === parts.length - 1;
        if (!node[part]) {
          node[part] = {
            meta: {
              name: part,
              path: parts.slice(0, i + 1).join("/"),
              type: isFile ? "file" : "folder",
            },
            children: {},
          };
        }
        node = node[part].children;
      });
    });
    const toArray = (obj) =>
      Object.values(obj)
        .map((n) => ({ ...n.meta, children: toArray(n.children) }))
        .sort((a, b) => {
          if (a.type !== b.type) return a.type === "folder" ? -1 : 1; // folders first
          return a.name.localeCompare(b.name);
        });
    return toArray(root);
  };

  toggleFolder = (path) => {
    this.setState((prev) => ({
      expandedFolders: {
        ...prev.expandedFolders,
        [path]: !prev.expandedFolders[path],
      },
    }));
  };

  toggleFileCheck = (path) => {
    this.setState((prev) => {
      const checked = { ...prev.frontendCheckedFiles };
      if (checked[path]) delete checked[path];
      else checked[path] = true;
      return { frontendCheckedFiles: checked };
    });
  };

  // Filter a flat file list by a search term (matches file name or full path)
  // and rebuild the tree so only matching files (and their folders) show.
  getFilteredTree = (fileList, fullTree, searchTerm) => {
    const term = (searchTerm || "").trim().toLowerCase();
    if (!term) return fullTree;
    const matched = (fileList || []).filter((p) =>
      String(p).toLowerCase().includes(term),
    );
    return this.buildFileTree(matched);
  };

  // Recursively render the folder tree: folders expand/collapse, files are checkboxes
  // forceOpen keeps every folder expanded (used while searching so matches are visible)
  renderFileTree = (nodes, depth = 0, forceOpen = false) => {
    return nodes.map((node) => {
      const pad = depth * 16 + 6;
      if (node.type === "folder") {
        const open = forceOpen || this.state.expandedFolders[node.path];
        return (
          <div key={node.path}>
            <div
              onClick={() => this.toggleFolder(node.path)}
              style={{
                paddingLeft: pad,
                cursor: "pointer",
                userSelect: "none",
                fontSize: "13px",
                lineHeight: "22px",
                color: "#344563",
              }}
            >
              <i
                className={`bi bi-caret-${open ? "down" : "right"}-fill`}
                style={{ fontSize: "9px", marginRight: 5 }}
              />
              <i
                className="bi bi-folder-fill"
                style={{ color: "#e3a008", marginRight: 6 }}
              />
              {node.name}
            </div>
            {open && this.renderFileTree(node.children, depth + 1, forceOpen)}
          </div>
        );
      }
      return (
        <div
          key={node.path}
          style={{
            paddingLeft: pad + 14,
            fontSize: "13px",
            lineHeight: "22px",
          }}
        >
          <label
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 6,
              margin: 0,
            }}
          >
            <input
              type="checkbox"
              checked={!!this.state.frontendCheckedFiles[node.path]}
              onChange={() => this.toggleFileCheck(node.path)}
            />
            <i
              className="bi bi-file-earmark-code"
              style={{ color: "#1f6feb" }}
            />
            {node.name}
          </label>
        </div>
      );
    });
  };

  // Load the selected project's file list from GitHub API via backend
  frontendFetchHandler = () => {
    const project = this.state.projectName || "";
    if (!project) {
      this.showToast("Please select a project first", "warning");
      return;
    }
    // Find matching UI repo for this project (case/space-insensitive so
    // "Playright" / "PlayRight" / "playright " all match)
    const norm = (s) =>
      String(s || "")
        .trim()
        .toLowerCase();
    const matchingRepos = this.state.allRepos.filter(
      (r) => norm(r.projectName) === norm(project) && norm(r.repoType) === "ui",
    );
    if (matchingRepos.length === 0) {
      this.showToast("No UI repository configured for this project", "warning");
      this.setState({ frontendFileList: [], frontendTree: [] });
      return;
    }
    const repoId =
      this.state.selectedFrontendRepo || matchingRepos[0].deploymentrepos_Id;

    this.setState({ frontendLoading: true });
    const fd = new FormData();
    fd.append("sId", this.state.sId);
    fd.append("deploymentrepos_Id", repoId);

    fetch(configData.api_url + "C_Deploymentrepos/getRepoFiles", {
      method: "POST",
      body: fd,
    })
      .then((r) => r.json())
      .then((data) => {
        this.setState({ frontendLoading: false });
        if (data.status === "success") {
          const list = data.files || [];
          this.setState({
            frontendFileList: list,
            frontendTree: this.buildFileTree(list),
            expandedFolders: { src: true },
            frontendCheckedFiles: {},
            frontendFileSearch: "",
          });
          this.showToast(
            `Loaded ${list.length} files from ${data.repoName || "repo"} (${data.branch || "main"})`,
            "success",
          );
        } else {
          this.showToast(data.message || "Failed to fetch files", "error");
          this.setState({ frontendFileList: [], frontendTree: [] });
        }
      })
      .catch((e) => {
        this.setState({ frontendLoading: false });
        this.showToast("Failed to connect to server", "error");
        console.error(e);
      });
  };

  // ── Backend tab: folder tree (reuses buildFileTree) ──────────────
  toggleBackendFolder = (path) => {
    this.setState((prev) => ({
      backendExpandedFolders: {
        ...prev.backendExpandedFolders,
        [path]: !prev.backendExpandedFolders[path],
      },
    }));
  };

  toggleBackendFileCheck = (path) => {
    this.setState((prev) => {
      const checked = { ...prev.backendCheckedFiles };
      if (checked[path]) delete checked[path];
      else checked[path] = true;
      return { backendCheckedFiles: checked };
    });
  };

  renderBackendFileTree = (nodes, depth = 0, forceOpen = false) => {
    return nodes.map((node) => {
      const pad = depth * 16 + 6;
      if (node.type === "folder") {
        const open = forceOpen || this.state.backendExpandedFolders[node.path];
        return (
          <div key={node.path}>
            <div
              onClick={() => this.toggleBackendFolder(node.path)}
              style={{
                paddingLeft: pad,
                cursor: "pointer",
                userSelect: "none",
                fontSize: "13px",
                lineHeight: "22px",
                color: "#344563",
              }}
            >
              <i
                className={`bi bi-caret-${open ? "down" : "right"}-fill`}
                style={{ fontSize: "9px", marginRight: 5 }}
              />
              <i
                className="bi bi-folder-fill"
                style={{ color: "#e3a008", marginRight: 6 }}
              />
              {node.name}
            </div>
            {open &&
              this.renderBackendFileTree(node.children, depth + 1, forceOpen)}
          </div>
        );
      }
      return (
        <div
          key={node.path}
          style={{
            paddingLeft: pad + 14,
            fontSize: "13px",
            lineHeight: "22px",
          }}
        >
          <label
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 6,
              margin: 0,
            }}
          >
            <input
              type="checkbox"
              checked={!!this.state.backendCheckedFiles[node.path]}
              onChange={() => this.toggleBackendFileCheck(node.path)}
            />
            <i
              className="bi bi-file-earmark-code"
              style={{ color: "#1f6feb" }}
            />
            {node.name}
          </label>
        </div>
      );
    });
  };

  // Move: checked tree files → "Moved Files List"
  handleBackendMoveFiles = () => {
    const checked = Object.keys(this.state.backendCheckedFiles).filter(
      (p) => this.state.backendCheckedFiles[p],
    );
    if (checked.length === 0) {
      this.showToast("Please check at least one file to move", "warning");
      return;
    }
    const existing = (this.state.backendMovedFiles || "")
      .split(/\r?\n/)
      .map((l) => l.trim())
      .filter((l) => l.length > 0);
    const merged = [...new Set([...existing, ...checked])].join("\n");
    this.setState({ backendMovedFiles: merged, backendCheckedFiles: {} });
  };

  toggleBackendMovedCheck = (path) => {
    this.setState((prev) => {
      const checked = { ...prev.backendMovedChecked };
      if (checked[path]) delete checked[path];
      else checked[path] = true;
      return { backendMovedChecked: checked };
    });
  };

  // Done: checked moved files → "Done Files List", removed from Moved
  handleBackendDoneFiles = () => {
    const checked = Object.keys(this.state.backendMovedChecked).filter(
      (p) => this.state.backendMovedChecked[p],
    );
    if (checked.length === 0) {
      this.showToast("Please check at least one moved file", "warning");
      return;
    }

    // Update file status to "Done" in the database
    const filePaths = checked.join(",");
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("deploymentRequest_Id", this.state.deploymentRequest_Id);
    formData.append("filePaths", filePaths);
    formData.append("deploymentFilestatus", "Done");

    fetch(configData.api_url + "C_Deploymentfiles/updateStatusBulk", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((r) => r.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          const moved = (this.state.backendMovedFiles || "")
            .split(/\r?\n/)
            .map((l) => l.trim())
            .filter((l) => l.length > 0);
          const doneExisting = (this.state.backendDoneFiles || "")
            .split(/\r?\n/)
            .map((l) => l.trim())
            .filter((l) => l.length > 0);
          const remainingMoved = moved.filter((p) => !checked.includes(p));
          const newDone = [...new Set([...doneExisting, ...checked])];
          this.setState({
            backendMovedFiles: remainingMoved.join("\n"),
            backendDoneFiles: newDone.join("\n"),
            backendMovedChecked: {},
          });
        }
      })
      .catch((e) => {
        console.error(e);
        this.showToast("Failed to update file status", "error");
      });
  };

  // Load the selected project's BACKEND structure from GitHub API via backend
  backendFetchHandler = () => {
    const project = this.state.backendProject || "";
    if (!project) {
      this.showToast("Please select a project first", "warning");
      return;
    }
    // Find matching API repo for this project (case/space-insensitive so
    // "Playright" / "PlayRight" / "playright " all match)
    const norm = (s) =>
      String(s || "")
        .trim()
        .toLowerCase();
    const matchingRepos = this.state.allRepos.filter(
      (r) =>
        norm(r.projectName) === norm(project) && norm(r.repoType) === "api",
    );
    if (matchingRepos.length === 0) {
      this.showToast(
        "No API repository configured for this project",
        "warning",
      );
      this.setState({ backendFileList: [], backendTree: [] });
      return;
    }
    const repoId =
      this.state.selectedBackendRepo || matchingRepos[0].deploymentrepos_Id;

    this.setState({ backendLoading: true });
    const fd = new FormData();
    fd.append("sId", this.state.sId);
    fd.append("deploymentrepos_Id", repoId);

    fetch(configData.api_url + "C_Deploymentrepos/getRepoFiles", {
      method: "POST",
      body: fd,
    })
      .then((r) => r.json())
      .then((data) => {
        this.setState({ backendLoading: false });
        if (data.status === "success") {
          const list = data.files || [];
          this.setState({
            backendFileList: list,
            backendTree: this.buildFileTree(list),
            backendExpandedFolders: { application: true },
            backendCheckedFiles: {},
            backendFileSearch: "",
          });
          this.showToast(
            `Loaded ${list.length} backend files from ${data.repoName || "repo"} (${data.branch || "main"})`,
            "success",
          );
        } else {
          this.showToast(data.message || "Failed to fetch files", "error");
          this.setState({ backendFileList: [], backendTree: [] });
        }
      })
      .catch((e) => {
        this.setState({ backendLoading: false });
        this.showToast("Failed to connect to server", "error");
        console.error(e);
      });
  };

  tablesFetchHandler = () => {
    console.log("Tables fetch", {
      environment: this.state.tablesEnvironment,
      project: this.state.tablesProject,
      userStory: this.state.tablesUserStory,
    });
  };

  frontendSubmitHandler = () => {
    console.log("Frontend submit", {
      environment: this.state.frontendEnvironment,
      project: this.state.frontendProject,
      userStory: this.state.frontendUserStory,
      code: this.state.frontendCode,
      npmPackages: this.state.frontendNpmPackages,
      employee: this.state.frontendEmployee,
      remarks: this.state.frontendRemarks,
    });
  };

  backendSubmitHandler = () => {
    console.log("Backend submit", {
      environment: this.state.backendEnvironment,
      project: this.state.backendProject,
      userStory: this.state.backendUserStory,
      code: this.state.backendCode,
      npmPackages: this.state.backendNpmPackages,
      employee: this.state.backendEmployee,
      remarks: this.state.backendRemarks,
    });
  };

  tablesSubmitHandler = () => {
    console.log("Tables submit", {
      environment: this.state.tablesEnvironment,
      project: this.state.tablesProject,
      userStory: this.state.tablesUserStory,
      code: this.state.tablesCode,
      npmPackages: this.state.tablesNpmPackages,
      employee: this.state.tablesEmployee,
      remarks: this.state.tablesRemarks,
    });
  };

  componentDidMount() {
    this.employeesfetchHandler();
    this.deploymentprojectsfetchHandler();
    this.userstoriestablefetchHandler();
    this.EnvironmentmasterfetchHandler();
    this.DeploymentactiontypemasterfetchHandler();
    this.TestcaseprioritymasterfetchHandler();
    this.fetchMyTeamHierarchy();
    this.fetchRepos();
    this.initCrossTeamContext();
  }

  // When opened via "Raise Changes" from the Linked Requests page, load the
  // parent (original) request's data so the developer can see what was
  // requested, and pre-fill the correct tab / reason before raising the
  // linked request.
  initCrossTeamContext = () => {
    const ctx = this.props.location && this.props.location.state
      ? this.props.location.state.crossTeamContext
      : null;
    if (!ctx || !ctx.parentRequestId) return;

    // Fill the tab that MATCHES the original request's type: a frontend/UI
    // request fills the Frontend tab, a backend/API request fills the Backend
    // tab. The other tab is left empty.
    const tab = ctx.parentRequestType === "UI" ? "frontend" : "backend";
    this.setState({
      crossTeamContext: ctx,
      crossTeamTargetTab: tab,
      activeTab: tab,
    });

    // Load the original request's files & packages so the developer can see
    // what was changed on the other side.
    this.fetchParentFilesAndPackages(ctx.parentRequestId, tab);

    // Pull the full parent request from the list so we can show/pre-fill it.
    fetch(configData.api_url + "C_Deploymentrequests/list", { method: "GET" })
      .then((r) => r.json())
      .then((data) => {
        if (data.status !== "success" || !Array.isArray(data.list)) return;
        const parent = data.list.find(
          (req) =>
            String(req.deploymentrequests_Id) === String(ctx.parentRequestId),
        );
        if (!parent) return;
        this.setState({ parentRequestData: parent });
        // Pre-fill ONLY the target tab's Project Details (the tab the developer
        // must work on). The other tab is left untouched.
        if (tab === "backend") {
          this.setState({
            requestCode: parent.requestCode || this.state.requestCode,
            backendEnvironment:
              parent.targetEnvironment || this.state.backendEnvironment,
            backendProject: parent.projectName || this.state.backendProject,
            backendUserStory:
              parent.sourceProject || this.state.backendUserStory,
            backendactionType:
              parent.actionType || this.state.backendactionType,
            backendpriority: parent.priority || this.state.backendpriority,
            backendreasonForDeployment:
              parent.reasonForDeployment ||
              this.state.backendreasonForDeployment,
          });
          if (parent.targetEnvironment) {
            this.fetchProjectsByEnvironment(
              parent.targetEnvironment,
              "backendFilteredProjects",
            );
          }
        } else {
          this.setState({
            requestCode: parent.requestCode || this.state.requestCode,
            targetEnvironment:
              parent.targetEnvironment || this.state.targetEnvironment,
            projectName: parent.projectName || this.state.projectName,
            sourceProject: parent.sourceProject || this.state.sourceProject,
            actionType: parent.actionType || this.state.actionType,
            priority: parent.priority || this.state.priority,
            reasonForDeployment:
              parent.reasonForDeployment || this.state.reasonForDeployment,
          });
          if (parent.targetEnvironment) {
            this.fetchProjectsByEnvironment(
              parent.targetEnvironment,
              "frontendFilteredProjects",
            );
          }
        }
      })
      .catch((e) => console.error("Failed to load parent request:", e));
  };

  // Fetch the original request's deployment files and packages for display.
  fetchParentFilesAndPackages = (parentRequestId, tab) => {
    const frmFiles = new FormData();
    frmFiles.append("sId", this.state.sId);
    fetch(configData.api_url + "C_Deploymentfiles/list", {
      method: "POST",
      body: frmFiles,
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status === "success") {
          const files = (data.list || []).filter(
            (f) =>
              String(f.deploymentRequest_Id) === String(parentRequestId),
          );
          // Pre-fill the "Moved Files List" with the original request's file
          // NAMES so they carry into the new request. The file PATHS are shown
          // separately in the "Select Files List" box. Only the target tab
          // (the team that must do the work) is filled.
          const names = files
            .map((f) => f.fileName)
            .filter((n) => n && String(n).trim().length > 0)
            .join("\n");
          this.setState((prev) => {
            const next = { parentFiles: files };
            if (tab === "backend") {
              next.backendMovedFiles = prev.backendMovedFiles || names;
            } else {
              next.frontendMovedFiles = prev.frontendMovedFiles || names;
            }
            return next;
          });
        }
      })
      .catch((e) => console.error("Failed to load parent files:", e));

    const frmPkg = new FormData();
    frmPkg.append("sId", this.state.sId);
    fetch(configData.api_url + "C_Deploymentpackages/list", {
      method: "POST",
      body: frmPkg,
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status === "success") {
          const pkgs = (data.list || []).filter(
            (p) =>
              String(p.deploymentRequest_Id) === String(parentRequestId),
          );
          this.setState({ parentPackages: pkgs });
        }
      })
      .catch((e) => console.error("Failed to load parent packages:", e));
  };

  fetchRepos = () => {
    fetch(configData.api_url + "C_Deploymentrepos/list", {
      method: "GET",
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ allRepos: data.list || [] });
        }
      })
      .catch((e) => console.error(e));
  };

  fetchMyTeamHierarchy = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    fetch(configData.api_url + "C_Deploymentteams/getMyTeamHierarchy", {
      method: "POST",
      body: formData,
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status === "success" && data.detail) {
          this.setState({
            teamLeadApprover: data.detail.teamLead_Id || "",
            managerApprover: data.detail.manager_Id || "",
            deploymentAssignee: data.detail.deploymentAssignee_Id || "",
            myTeamName: data.detail.teamName || "",
          });
        }
      })
      .catch((e) => console.error(e));
  };
  //fetch api list
  deploymentprojectsfetchHandler = () => {
    fetch(configData.api_url + "C_Deploymentprojects/list", {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ deploymentprojects: data.list });
        }
      });
  };

  fetchProjectsByEnvironment = (environmentName, stateKey) => {
    const formData = new FormData();
    formData.append("environmentName", environmentName);
    fetch(configData.api_url + "C_Deploymentrepos/projectsByEnv", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ [stateKey]: data.projects || [] });
        }
      });
  };
  userstoriestablefetchHandler = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Userstoriestable/list", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ userstoriestable: data.list });
        }
      });
  };
  employeesfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Employees/list", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ employees: data.list });
        }
      });
  };
  EnvironmentmasterfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Environmentmaster/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ environmentmaster: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  };
  DeploymentactiontypemasterfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Deploymentactiontypemaster/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ Deploymentactiontypemaster: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  };
  TestcaseprioritymasterfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Testcaseprioritymaster/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ Testcaseprioritymaster: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  };
  renderChips = (listField, items) => {
    if (!items || items.length === 0) return null;
    return (
      <ul
        style={{
          marginTop: "10px",
          marginBottom: 0,
          paddingLeft: "20px",
          color: "#344563",
          fontSize: "14px",
        }}
      >
        {items.map((item, index) => (
          <li key={index} style={{ marginBottom: "4px", lineHeight: 1.5 }}>
            <span>{item}</span>
            <button
              type="button"
              aria-label="Remove"
              onClick={() => this.removeFromList(listField, index)}
              style={{
                background: "transparent",
                border: "none",
                color: "#c92a2a",
                opacity: 0.75,
                fontSize: "13px",
                marginLeft: "10px",
                padding: 0,
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              Remove
            </button>
          </li>
        ))}
      </ul>
    );
  };

  renderSectionLabel = (text) => (
    <div
      style={{
        fontSize: "11.5px",
        fontWeight: 700,
        color: "#6c7a8a",
        textTransform: "uppercase",
        letterSpacing: "0.6px",
        marginBottom: "14px",
        display: "flex",
        alignItems: "center",
        gap: "8px",
      }}
    >
      {text}
    </div>
  );
  //add event
  DeploymentapprovalssubmitHandler = (e) => {
    e.preventDefault();
    const today = new Date();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const yyyy = today.getFullYear();
    const approvedOnDate = `${mm}-${dd}-${yyyy}`;
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("deploymentRequest_Id", this.state.deploymentRequest_Id);
    formData.append("approverId", this.state.approverId);
    formData.append("approvalStatus", this.state.approvalStatus);
    formData.append("approvalRemarks", this.state.approvalRemarks);
    formData.append("approvedOn", approvedOnDate);
    fetch(configData.api_url + "C_Deploymentapprovals/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          //this.DeploymentapprovalsfetchHandler();
          //this.handleOffcanvasClose();
          this.setState({
            deploymentRequestId: "",
            approverId: "",
            approvalStatus: "",
            approvalRemarks: "",
            approvedOn: "",
          });
        }
      })
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      });
  };
  BackendDeploymentapprovalssubmitHandler = (e) => {
    e.preventDefault();
    const today = new Date();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const yyyy = today.getFullYear();
    const approvedOnDate = `${mm}-${dd}-${yyyy}`;
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("deploymentRequest_Id", this.state.deploymentRequest_Id);
    formData.append("approverId", this.state.backendapproverId);
    formData.append("approvalStatus", this.state.backendapprovalStatus);
    formData.append("approvalRemarks", this.state.backendapprovalRemarks);
    formData.append("approvedOn", approvedOnDate);
    fetch(configData.api_url + "C_Deploymentapprovals/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          //this.DeploymentapprovalsfetchHandler();
          //this.handleOffcanvasClose();
          this.setState({
            deploymentRequestId: "",
            backendapproverId: "",
            backendapprovalStatus: "",
            backendapprovalRemarks: "",
            approvedOn: "",
          });
        }
      })
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      });
  };
  tablesApprovalSubmitHandler = (e) => {
    e.preventDefault();
    const today = new Date();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const yyyy = today.getFullYear();
    const approvedOnDate = `${mm}-${dd}-${yyyy}`;
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("deploymentRequest_Id", this.state.deploymentRequest_Id);
    formData.append("approverId", this.state.tablesEmployee);
    formData.append("approvalStatus", this.state.tablesapprovalStatus);
    formData.append("approvalRemarks", this.state.tablesRemarks);
    formData.append("approvedOn", approvedOnDate);
    fetch(configData.api_url + "C_Deploymentapprovals/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          //this.DeploymentapprovalsfetchHandler();
          //this.handleOffcanvasClose();
          this.setState({
            deploymentRequestId: "",
            tablesEmployee: "",
            tablesapprovalStatus: "",
            tablesRemarks: "",
            approvedOn: "",
          });
        }
      })
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      });
  };
  //frontend
  DeploymentpackagessubmitHandler = (e) => {
    // Skip if no packages provided
    const pkgList = this.state.frontendNpmPackagesList;
    if (
      !pkgList ||
      (Array.isArray(pkgList)
        ? pkgList.length === 0
        : String(pkgList).trim() === "")
    ) {
      return;
    }
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("deploymentRequest_Id", this.state.deploymentRequest_Id);
    formData.append("packageName", this.state.frontendNpmPackagesList);
    formData.append("version", this.state.version);
    formData.append("buildNumber", this.state.buildNumber);
    formData.append("artifactPath", this.state.artifactPath);
    formData.append("packageType", this.state.packageType);
    formData.append(
      "deploymentPackagesStatus",
      this.state.deploymentPackagesStatus,
    );

    fetch(configData.api_url + "C_Deploymentpackages/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          // this.DeploymentpackagesfetchHandler();
          // this.handleOffcanvasClose();
          this.setState({
            deploymentRequestId: "",
            frontendNpmPackagesList: "",
            packageName: "",
            version: "",
            buildNumber: "",
            artifactPath: "",
            packageType: "",
            deploymentPackagesStatus: "",
          });
        }
      })
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      });
  };
  FrontendDeploymentfilessubmitHandler = (e) => {
    // Files come from the "Moved Files List" — inserted with status "Moved"
    // DevOps will later move them to "Done" which updates the status
    const files = (this.state.frontendMovedFiles || "")
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter((line) => line.length > 0);
    if (files.length === 0) {
      return;
    }

    // ALL files in ONE call — names & paths as comma-separated strings
    const fileNames = files
      .map((file) => file.split(/[/\\]/).pop()) // last segment of each
      .join(",");
    const filePaths = files.join(",");
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("deploymentRequest_Id", this.state.deploymentRequest_Id);
    formData.append("fileName", fileNames);
    formData.append("filePath", filePaths);
    formData.append("fileType", this.state.packageType);
    formData.append("version", this.state.version);
    formData.append("deploymentFilestatus", "Moved");

    fetch(configData.api_url + "C_Deploymentfiles/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({
            frontendSelectFiles: "",
            frontendMovedFiles: "",
            frontendDoneFiles: "",
            version: "",
            packageType: "",
            deploymentFilestatus: "",
          });
        }
      })
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      });
  };
  DeploymentrequestssubmitHandler = (callback) => {
    // Auto-fill requestDate with today's date (the day the request is sent)
    const today = new Date();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const yyyy = today.getFullYear();
    const requestDate = `${yyyy}-${mm}-${dd}`;

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("requestCode", this.state.requestCode);
    formData.append("projectName", this.state.projectName);
    formData.append("sourceProject", this.state.sourceProject);
    formData.append("targetEnvironment", this.state.targetEnvironment);
    formData.append("actionType", this.state.actionType);
    formData.append("priority", this.state.priority);
    formData.append("reasonForDeployment", this.state.reasonForDeployment);
    formData.append("requestedBy", this.state.uId);
    formData.append("assignedTo", this.state.assignedTo);
    formData.append("requestDate", requestDate);
    formData.append("deploymentDate", this.state.deploymentDate);
    formData.append("deploymentStatus", this.state.deploymentStatus);
    formData.append("remarks", this.state.remarks);
    formData.append("status", this.state.status);
    formData.append("requestType", "UI");
    formData.append("currentStage", "Draft");
    if (this.state.teamLeadApprover)
      formData.append("teamLeadApprover", this.state.teamLeadApprover);
    if (this.state.managerApprover)
      formData.append("managerApprover", this.state.managerApprover);
    if (this.state.deploymentAssignee)
      formData.append("deploymentAssignee", this.state.deploymentAssignee);
    // Link this request back to the parent so the backend can complete the
    // cross-team link and advance the parent out of WaitingForLinkedDev.
    if (this.state.crossTeamContext) {
      formData.append("linkId", this.state.crossTeamContext.linkId);
      formData.append(
        "parentRequestId",
        this.state.crossTeamContext.parentRequestId,
      );
    }

    //***tableData*

    fetch(configData.api_url + "C_Deploymentrequests/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          // Store the created request ID for cross-team check
          this.setState({
            lastCreatedRequestId: data.insertId || null,
            crossTeamRequestType: "UI",
            showCrossTeamModal: true,
          });
          if (callback && data.insertId) callback(data.insertId);
        }
      })
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      });
  };

  handleCrossTeamConfirm = (crossTeamData) => {
    const { lastCreatedRequestId, crossTeamRequestType, teamLeadApprover } =
      this.state;
    if (!lastCreatedRequestId) {
      this.setState({ showCrossTeamModal: false });
      setTimeout(() => {
        window.location.href = "/deploymentrequests";
      }, 1000);
      return;
    }

    // First call autoRoute to populate TL, Manager, Assignee from team config
    const autoRouteData = new FormData();
    autoRouteData.append("sId", this.state.sId);
    autoRouteData.append("deploymentrequests_Id", lastCreatedRequestId);
    fetch(configData.api_url + "C_Deploymentrequests/autoRoute", {
      method: "POST",
      body: autoRouteData,
    })
      .then((r) => r.json())
      .then(() => {
        // Then proceed with crossTeamCheck
        var formData = new FormData();
        formData.append("sId", this.state.sId);
        formData.append("deploymentrequests_Id", lastCreatedRequestId);
        formData.append("requestType", crossTeamRequestType);
        formData.append(
          "hasCrossTeamDependency",
          crossTeamData.hasCrossTeamDependency,
        );
        if (crossTeamData.assignedCrossTeamDev) {
          formData.append(
            "assignedCrossTeamDev",
            crossTeamData.assignedCrossTeamDev,
          );
        }
        if (teamLeadApprover) {
          formData.append("teamLeadApprover", teamLeadApprover);
        }

        fetch(configData.api_url + "C_Deploymentrequests/crossTeamCheck", {
          method: "POST",
          mode: "cors",
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            this.showToast(data.message, data.status);
            this.setState({
              showCrossTeamModal: false,
              requestCode: "",
              projectName: "",
              sourceProject: "",
              targetEnvironment: "",
              actionType: "",
              priority: "",
              reasonForDeployment: "",
              requestedBy: "",
              assignedTo: "",
              requestDate: "",
              deploymentDate: "",
              deploymentStatus: "",
              remarks: "",
              status: "",
              lastCreatedRequestId: null,
            });
            // Redirect to deployment requests list
            setTimeout(() => {
              window.location.href = "/deploymentrequests";
            }, 1000);
          })
          .catch((error) => {
            console.error("Cross-team check error:", error);
            this.showToast("Failed to process cross-team check", "error");
          });
      })
      .catch((error) => {
        console.error("Auto-route error:", error);
        this.showToast("Failed to auto-route request", "error");
      });
  };

  handleSubmitClick = (e) => {
    e.preventDefault();
    if (!this.state.assignedTo) {
      this.showToast("No DevOps assignee configured for the selected environment. Please contact admin.", "error");
      return;
    }
    const movedFiles = (this.state.frontendMovedFiles || "").trim();
    if (!movedFiles) {
      this.showToast("Please select files from the repository before submitting.", "error");
      return;
    }
    this.DeploymentrequestssubmitHandler((insertId) => {
      this.setState({ deploymentRequest_Id: insertId }, () => {
        this.FrontendDeploymentfilessubmitHandler();
        this.DeploymentpackagessubmitHandler();
      });
    });
  };
  //backend
  handleBackendSubmitClick = (e) => {
    e.preventDefault();
    if (!this.state.backendEmployee) {
      this.showToast("No DevOps assignee configured for the selected environment. Please contact admin.", "error");
      return;
    }
    const movedFiles = (this.state.backendMovedFiles || "").trim();
    if (!movedFiles) {
      this.showToast("Please select files from the repository before submitting.", "error");
      return;
    }
    this.BackendDeploymentrequestssubmitHandler((insertId) => {
      this.setState({ deploymentRequest_Id: insertId }, () => {
        this.BackendDeploymentpackagessubmitHandler();
        this.BackendDeploymentfilessubmitHandler();
      });
    });
  };
  BackendDeploymentrequestssubmitHandler = (callback) => {
    // Auto-fill requestDate with today's date (the day the request is sent)
    const today = new Date();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const yyyy = today.getFullYear();
    const requestDate = `${yyyy}-${mm}-${dd}`;

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("requestCode", this.state.requestCode);
    formData.append("projectName", this.state.backendProject);
    formData.append("sourceProject", this.state.backendUserStory);
    formData.append("targetEnvironment", this.state.backendEnvironment);
    formData.append("actionType", this.state.backendactionType);
    formData.append("priority", this.state.backendpriority);
    formData.append(
      "reasonForDeployment",
      this.state.backendreasonForDeployment,
    );
    formData.append("requestedBy", this.state.uId);
    formData.append("assignedTo", this.state.backendEmployee);
    formData.append("requestDate", requestDate);
    formData.append("deploymentDate", this.state.deploymentDate);
    formData.append("deploymentStatus", this.state.deploymentStatus);
    formData.append("remarks", this.state.backendRemarks);
    formData.append("status", this.state.backendstatus);
    formData.append("requestType", "API");
    formData.append("currentStage", "Draft");
    if (this.state.teamLeadApprover)
      formData.append("teamLeadApprover", this.state.teamLeadApprover);
    if (this.state.managerApprover)
      formData.append("managerApprover", this.state.managerApprover);
    if (this.state.deploymentAssignee)
      formData.append("deploymentAssignee", this.state.deploymentAssignee);
    // Link this request back to the parent so the backend can complete the
    // cross-team link and advance the parent out of WaitingForLinkedDev.
    if (this.state.crossTeamContext) {
      formData.append("linkId", this.state.crossTeamContext.linkId);
      formData.append(
        "parentRequestId",
        this.state.crossTeamContext.parentRequestId,
      );
    }

    //***tableData*

    fetch(configData.api_url + "C_Deploymentrequests/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({
            lastCreatedRequestId: data.insertId || null,
            crossTeamRequestType: "API",
            showCrossTeamModal: true,
            requestCode: "",
            projectName: "",
            sourceProject: "",
            targetEnvironment: "",
            actionType: "",
            priority: "",
            reasonForDeployment: "",
            requestedBy: "",
            assignedTo: "",
            requestDate: "",
            deploymentDate: "",
            deploymentStatus: "",
            remarks: "",
            status: "",
          });
          if (callback && data.insertId) callback(data.insertId);
        }
      })
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      });
  };
  BackendDeploymentpackagessubmitHandler = (e) => {
    // Skip if no packages provided
    const bkPkgList = this.state.backendFilesChangesList;
    if (
      !bkPkgList ||
      (Array.isArray(bkPkgList)
        ? bkPkgList.length === 0
        : String(bkPkgList).trim() === "")
    ) {
      return;
    }
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("deploymentRequestId", this.state.deploymentRequestId);
    formData.append("packageName", this.state.backendFilesChangesList);
    formData.append("version", this.state.backendversion);
    formData.append("buildNumber", this.state.backendbuildNumber);
    formData.append("artifactPath", this.state.artifactPath);
    formData.append("packageType", this.state.backendpackageType);
    formData.append(
      "deploymentPackagesStatus",
      this.state.backenddeploymentPackagesStatus,
    );

    fetch(configData.api_url + "C_Deploymentpackages/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          // this.DeploymentpackagesfetchHandler();
          // this.handleOffcanvasClose();
          this.setState({
            deploymentRequestId: "",
            frontendNpmPackagesList: "",
            packageName: "",
            backendversion: "",
            backendbuildNumber: "",
            artifactPath: "",
            backendpackageType: "",
            backenddeploymentPackagesStatus: "",
          });
        }
      })
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      });
  };
  BackendDeploymentfilessubmitHandler = (e) => {
    // Files come from the BACKEND "Moved Files List" — inserted with status "Moved"
    // DevOps will later move them to "Done" which updates the status
    const files = (this.state.backendMovedFiles || "")
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter((line) => line.length > 0);
    if (files.length === 0) {
      return;
    }

    // ALL files in ONE call — names & paths as comma-separated strings
    const fileNames = files
      .map((file) => file.split(/[/\\]/).pop()) // last segment of each
      .join(",");
    const filePaths = files.join(",");
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("deploymentRequest_Id", this.state.deploymentRequest_Id);
    formData.append("fileName", fileNames);
    formData.append("filePath", filePaths);
    formData.append("fileType", this.state.backendpackageType);
    formData.append("version", this.state.backendversion);
    formData.append("deploymentFilestatus", "Moved");

    fetch(configData.api_url + "C_Deploymentfiles/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({
            backendCheckedFiles: {},
            backendMovedFiles: "",
            backendMovedChecked: {},
            backendDoneFiles: "",
            backendversion: "",
            backendpackageType: "",
            backenddeploymentPackagesStatus: "",
          });
        }
      })
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      });
  };
  //tables
  handletablesSubmitClick = (e) => {
    e.preventDefault();
    if (!this.state.tablesassignedTo) {
      this.showToast("No DevOps assignee configured for the selected environment. Please contact admin.", "error");
      return;
    }
    this.TablesDeploymentubmitHandler();
    this.TablesDeploymentrequestssubmitHandler();
  };
  TablesDeploymentubmitHandler = (e) => {
    // Auto-fill requestDate with today's date (the day the request is sent)
    const today = new Date();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const yyyy = today.getFullYear();
    const requestDate = `${yyyy}-${mm}-${dd}`;

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("requestCode", this.state.requestCode);
    formData.append("projectName", this.state.tablesProject);
    formData.append("sourceProject", this.state.tablesUserStory);
    formData.append("targetEnvironment", this.state.tablesEnvironment);
    formData.append("actionType", this.state.tablesactionType);
    formData.append("priority", this.state.tablespriority);
    formData.append(
      "reasonForDeployment",
      this.state.tablesreasonForDeployment,
    );
    formData.append("requestedBy", this.state.uId);
    formData.append("assignedTo", this.state.tablesassignedTo);
    formData.append("requestDate", requestDate);
    formData.append("deploymentDate", this.state.tablesdeploymentDate);
    formData.append("deploymentStatus", this.state.tablesdeploymentStatus);
    formData.append("remarks", this.state.tablesremarks);
    formData.append("status", this.state.tablesstatus);

    //***tableData*

    fetch(configData.api_url + "C_Deploymentrequests/add1", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          // this.DeploymentrequestsfetchHandler();  // not defined in this component
          // this.handleOffcanvasClose();            // not defined in this component
          this.setState({
            requestCode: "",
            projectName: "",
            sourceProject: "",
            targetEnvironment: "",
            actionType: "",
            priority: "",
            reasonForDeployment: "",
            requestedBy: "",
            assignedTo: "",
            requestDate: "",
            deploymentDate: "",
            deploymentStatus: "",
            remarks: "",
            status: "",
          });
        }
      })
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      });
  };
  TablesDeploymentrequestssubmitHandler = (e) => {
    // Files come from the BACKEND "Done Files List" (Select -> Move -> Moved -> Done)
    const files = (this.state.backendDoneFiles || "")
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter((line) => line.length > 0);

    // ALL files in ONE call — names & paths as comma-separated strings
    const fileNames = files
      .map((file) => file.split(/[/\\]/).pop()) // last segment of each
      .join(",");
    const filePaths = files.join(",");
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("deploymentRequest_Id", this.state.deploymentRequest_Id);
    formData.append("fileName", fileNames);
    formData.append("filePath", filePaths);
    formData.append("fileType", this.state.tablespackageType);
    formData.append("version", this.state.tablesversion);
    formData.append(
      "deploymentFilestatus",
      this.state.tablesdeploymentPackagesStatus,
    );

    fetch(configData.api_url + "C_Deploymentfiles/add1", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({
            backendCheckedFiles: {},
            backendMovedFiles: "",
            backendMovedChecked: {},
            backendDoneFiles: "",
            backendversion: "",
            backendpackageType: "",
            backenddeploymentPackagesStatus: "",
          });
        }
      })
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      });
  };
  render() {
    return (
      <div
        style={{
          background: "#f5f7fb",
          minHeight: "100vh",
          padding: "28px 24px",
        }}
      >
        <div style={{ marginBottom: "20px" }}>
          <h3
            style={{
              fontWeight: 700,
              color: "#1f2d3d",
              margin: "0 0 4px",
              letterSpacing: "-0.2px",
            }}
          >
            Deployment Request
          </h3>
          <p style={{ color: "#6c7a8a", fontSize: "13.5px", margin: 0 }}>
            Submit deployment requests for Frontend, Backend, and Database
            changes
          </p>
        </div>

        <Card
          style={{
            border: "none",
            borderRadius: "12px",
            boxShadow:
              "0 1px 3px rgba(16,24,40,0.06), 0 1px 2px rgba(16,24,40,0.04)",
            background: "#fff",
          }}
        >
          <Card.Body style={{ padding: "24px 28px" }}>
            <Tabs
              activeKey={this.state.activeTab}
              onSelect={this.handleTabChange}
              className="mb-4"
            >
              <Tab eventKey="frontend" title="Frontend">
                <Form>
                  <div
                    style={{
                      background: "#fafbfc",
                      border: "1px solid #ecf0f5",
                      borderRadius: "10px",
                      padding: "18px 20px",
                      marginBottom: "20px",
                    }}
                  >
                    {this.renderSectionLabel("Project Details")}
                    <Row>
                      <Col lg="3" md="6">
                        <Form.Group className="mb-3">
                          <Form.Label>Environment</Form.Label>
                          <Form.Select
                            name="targetEnvironment"
                            value={this.state.targetEnvironment}
                            onChange={this.handletargetEnvironmentChange}
                          >
                            <option value="">Select Environment</option>
                            {this.state.environmentmaster.map((api, index) => (
                              <option key={index} value={api.environmentName}>
                                {api.environmentName}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="6">
                        <Form.Group className="mb-3">
                          <Form.Label>Project</Form.Label>
                          <Form.Select
                            name="projectName"
                            value={this.state.projectName}
                            onChange={this.handleprojectNameChange}
                            disabled={!this.state.targetEnvironment}
                          >
                            <option value="">Select Project</option>
                            {this.state.frontendFilteredProjects.map(
                              (projName, index) => (
                                <option key={index} value={projName}>
                                  {projName}
                                </option>
                              ),
                            )}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="6">
                        <Form.Group className="mb-3">
                          <Form.Label>User Story</Form.Label>
                          <Form.Select
                            name="sourceProject"
                            value={this.state.sourceProject}
                            onChange={this.handlesourceProjectChange}
                            disabled={!this.state.projectName}
                          >
                            <option value="">Select User Story</option>
                            {this.state.userstoriestable
                              .filter(
                                (api) =>
                                  api.projectName === this.state.projectName,
                              )
                              .map((api, index) => (
                                <option key={index} value={api.userStory}>
                                  {api.userStory}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col
                        lg="3"
                        md="6"
                        style={{
                          display: "flex",
                          alignItems: "end",
                          paddingBottom: "16px",
                          gap: "8px",
                        }}
                      >
                        <Button
                          className="w-100"
                          style={{
                            backgroundColor: "#1f6feb",
                            borderColor: "#1f6feb",
                            borderRadius: "8px",
                            fontWeight: 500,
                            padding: "8px 18px",
                            fontSize: "14px",
                          }}
                          onClick={this.frontendFetchHandler}
                          disabled={this.state.frontendLoading}
                        >
                          {this.state.frontendLoading ? (
                            <>
                              <Spinner
                                animation="border"
                                size="sm"
                                className="me-1"
                              />{" "}
                              Loading...
                            </>
                          ) : (
                            "Fetch"
                          )}
                        </Button>
                        {this.state.frontendTree.length > 0 && (
                          <Button
                            variant="outline-secondary"
                            style={{
                              borderRadius: "8px",
                              padding: "8px 12px",
                              fontSize: "14px",
                            }}
                            onClick={this.frontendFetchHandler}
                            disabled={this.state.frontendLoading}
                            title="Refresh file tree from GitHub"
                          >
                            <i className="bi bi-arrow-clockwise"></i>
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </div>
                  <div
                    style={{
                      background: "#fafbfc",
                      border: "1px solid #ecf0f5",
                      borderRadius: "10px",
                      padding: "18px 20px",
                      marginBottom: "20px",
                    }}
                  >
                    {this.renderSectionLabel("Project Structure")}
                    <Row>
                      <Col lg="4" md="12">
                        <Row>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label>Select Files List</Form.Label>
                              {this.state.frontendTree.length > 0 && (
                                <Form.Control
                                  type="text"
                                  size="sm"
                                  className="mb-2"
                                  placeholder="Search files by name or folder..."
                                  value={this.state.frontendFileSearch}
                                  onChange={(e) =>
                                    this.setState({
                                      frontendFileSearch: e.target.value,
                                    })
                                  }
                                />
                              )}
                              <div
                                style={{
                                  border: "1px solid #ced4da",
                                  borderRadius: "6px",
                                  background: "#fff",
                                  height: "220px",
                                  overflow: "auto",
                                  padding: "8px 6px",
                                }}
                              >
                                {this.state.frontendLoading ? (
                                  <div
                                    style={{
                                      textAlign: "center",
                                      paddingTop: "80px",
                                    }}
                                  >
                                    <Spinner animation="border" size="sm" />{" "}
                                    <span
                                      style={{
                                        color: "#9aa6b2",
                                        fontSize: "13px",
                                      }}
                                    >
                                      Fetching files from GitHub...
                                    </span>
                                  </div>
                                ) : this.state.frontendTree.length === 0 ? (
                                  this.renderCrossTeamOriginalPaths("frontend") || (
                                    <div
                                      style={{
                                        color: "#9aa6b2",
                                        fontSize: "13px",
                                      }}
                                    >
                                      Select a project and click Fetch to load
                                      files from GitHub
                                    </div>
                                  )
                                ) : (
                                  (() => {
                                    const term =
                                      this.state.frontendFileSearch.trim();
                                    const tree = this.getFilteredTree(
                                      this.state.frontendFileList,
                                      this.state.frontendTree,
                                      term,
                                    );
                                    if (term && tree.length === 0) {
                                      return (
                                        <div
                                          style={{
                                            color: "#9aa6b2",
                                            fontSize: "13px",
                                          }}
                                        >
                                          No files match "{term}"
                                        </div>
                                      );
                                    }
                                    return this.renderFileTree(
                                      tree,
                                      0,
                                      !!term,
                                    );
                                  })()
                                )}
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row style={{ float: "right" }}>
                          <Col lg="3" md="3">
                            <Button onClick={this.handleFrontendMoveFiles}>
                              Move
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg="4" md="12">
                        <Row>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label>Moved Files List</Form.Label>
                              <div
                                style={{
                                  border: "1px solid #ced4da",
                                  borderRadius: "6px",
                                  background: "#fff",
                                  height: "220px",
                                  overflow: "auto",
                                  padding: "8px 10px",
                                }}
                              >
                                {(() => {
                                  const moved = (
                                    this.state.frontendMovedFiles || ""
                                  )
                                    .split(/\r?\n/)
                                    .map((l) => l.trim())
                                    .filter((l) => l.length > 0);
                                  if (moved.length === 0) {
                                    return (
                                      <div
                                        style={{
                                          color: "#9aa6b2",
                                          fontSize: "13px",
                                        }}
                                      >
                                        Move files here from the tree
                                      </div>
                                    );
                                  }
                                  return moved.map((path, i) => (
                                    <label
                                      key={i}
                                      title={path}
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 6,
                                        margin: 0,
                                        fontSize: "13px",
                                        lineHeight: "22px",
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={
                                          !!this.state.frontendMovedChecked[
                                            path
                                          ]
                                        }
                                        onChange={() =>
                                          this.toggleMovedCheck(path)
                                        }
                                      />
                                      <i
                                        className="bi bi-file-earmark-check"
                                        style={{ color: "#16a34a" }}
                                      />
                                      {path.split("/").pop()}
                                    </label>
                                  ));
                                })()}
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row style={{ float: "right" }}>
                          <Col lg="3" md="3">
                            <Button onClick={this.handleFrontendDoneFiles}>
                              Done
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg="4" md="12">
                        <Form.Group className="mb-3">
                          <Form.Label>Done Files List</Form.Label>
                          <div
                            style={{
                              border: "1px solid #ced4da",
                              borderRadius: "6px",
                              background: "#fff",
                              height: "220px",
                              overflow: "auto",
                              padding: "8px 10px",
                            }}
                          >
                            {(() => {
                              const done = (this.state.frontendDoneFiles || "")
                                .split(/\r?\n/)
                                .map((l) => l.trim())
                                .filter((l) => l.length > 0);
                              if (done.length === 0) {
                                return (
                                  <div
                                    style={{
                                      color: "#9aa6b2",
                                      fontSize: "13px",
                                    }}
                                  >
                                    Completed files will appear here
                                  </div>
                                );
                              }
                              return done.map((path, i) => (
                                <div
                                  key={i}
                                  title={path}
                                  style={{
                                    fontSize: "13px",
                                    lineHeight: "22px",
                                    color: "#16794c",
                                  }}
                                >
                                  <i
                                    className="bi bi-check2-circle"
                                    style={{ marginRight: 6 }}
                                  />
                                  {path.split("/").pop()}
                                </div>
                              ));
                            })()}
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                  <div
                    style={{
                      background: "#fafbfc",
                      border: "1px solid #ecf0f5",
                      borderRadius: "10px",
                      padding: "18px 20px",
                      marginBottom: "20px",
                    }}
                  >
                    {this.renderSectionLabel("Deployment Details")}
                    <Row>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Action Type</Form.Label>
                          <Form.Select
                            type="text"
                            onChange={this.handleactionTypeChange}
                            className="form-control"
                            name="actionType"
                            value={this.state.actionType}
                            required="required"
                            placeholder="Enter Action Type"
                          >
                            <option defaultValue>Select Action Type</option>
                            {this.state.Deploymentactiontypemaster.map(
                              (api, index, idx) => (
                                <option key={index} value={api.actionType}>
                                  {api.actionType}
                                </option>
                              ),
                            )}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Priority</Form.Label>
                          <Form.Select
                            type="text"
                            onChange={this.handlepriorityChange}
                            className="form-control"
                            name="priority"
                            value={this.state.priority}
                            required="required"
                            placeholder="Enter Priority"
                          >
                            <option defaultValue>Select</option>
                            {this.state.Testcaseprioritymaster.map(
                              (api, index, idx) => (
                                <option key={index} value={api.low}>
                                  {api.low}
                                </option>
                              ),
                            )}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Reason For Deployment</Form.Label>
                          <Form.Control
                            as={"textarea"}
                            rows={2}
                            name="reasonForDeployment"
                            value={this.state.reasonForDeployment}
                            onChange={this.handlereasonForDeploymentChange}
                            placeholder="Enter reason for deployment"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Status</Form.Label>
                          <Form.Control
                            type="text"
                            onChange={this.handlestatusChange}
                            className="form-control"
                            name="status"
                            value={this.state.status}
                            required="required"
                            placeholder="Enter Status"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6" md="12">
                        <Form.Group className="mb-3">
                          <Form.Label>NPM Packages List</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            name="frontendNpmPackages"
                            value={this.state.frontendNpmPackages}
                            onChange={this.handleFrontendNpmPackagesChange}
                            placeholder="Enter one package per line, then click Add"
                          />
                          <div className="d-flex justify-content-end mt-2">
                            <Button
                              size="sm"
                              style={{
                                // backgroundColor: "#fff",
                                //color: "#1f6feb",
                                // border: "1px solid #1f6feb",
                                // borderRadius: "8px",
                                padding: "6px 14px",
                                fontSize: "13px",
                                fontWeight: 500,
                              }}
                              onClick={() =>
                                this.addToList(
                                  "frontendNpmPackages",
                                  "frontendNpmPackagesList",
                                )
                              }
                            >
                              + Add
                            </Button>
                          </div>
                          {this.renderChips(
                            "frontendNpmPackagesList",
                            this.state.frontendNpmPackagesList,
                          )}
                        </Form.Group>
                      </Col>
                      <Col lg="6" md="12">
                        <Form.Group className="mb-3">
                          <Form.Label>Assigned Employee</Form.Label>
                          <Form.Select
                            name="assignedTo"
                            value={this.state.assignedTo}
                            onChange={this.handleassignedToChange}
                            disabled
                          >
                            <option value="">Select Employee</option>
                            {this.state.employees
                              .filter(
                                (api) =>
                                  api.dName && api.dName.toUpperCase() === "IT",
                              )
                              .map((api, index) => (
                                <option key={index} value={api.employees_Id}>
                                  {api.fName}&nbsp;{api.lName}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3">
                          <Form.Label>Remarks</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            name="remarks"
                            value={this.state.remarks}
                            onChange={this.handleremarksChange}
                            placeholder="Add frontend remarks"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Version</Form.Label>
                          <Form.Control
                            type="text"
                            name="version"
                            value={this.state.version}
                            onChange={this.handleversionChange}
                            placeholder="Enter version"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Build Number</Form.Label>
                          <Form.Control
                            type="text"
                            name="buildNumber"
                            value={this.state.buildNumber}
                            onChange={this.handlebuildNumberChange}
                            placeholder="Enter build number"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Package Type</Form.Label>
                          <Form.Control
                            type="text"
                            name="packageType"
                            value={this.state.packageType}
                            onChange={this.handlepackageTypeChange}
                            placeholder="Enter package type"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Deployment Packages Status</Form.Label>
                          <Form.Control
                            type="text"
                            name="deploymentPackagesStatus"
                            value={this.state.deploymentPackagesStatus}
                            onChange={this.handledeploymentPackagesStatusChange}
                            placeholder="Enter deployment packages status"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                  <div className="d-flex justify-content-end">
                    <Button
                      style={{
                        backgroundColor: "#16a34a",
                        borderColor: "#16a34a",
                        borderRadius: "8px",
                        padding: "9px 28px",
                        fontWeight: 600,
                        fontSize: "14px",
                      }}
                      onClick={this.handleSubmitClick}
                    >
                      Submit Request
                    </Button>
                  </div>
                  <hr />
                  {this.state.uId == this.state.managerApprover && (
                  <div
                    style={{
                      background: "#fafbfc",
                      border: "1px solid #ecf0f5",
                      borderRadius: "10px",
                      padding: "18px 20px",
                      marginBottom: "20px",
                    }}
                  >
                    {this.renderSectionLabel("Approved Manager")}
                    <Row>
                      <Col lg="3" md="12">
                        <Form.Group className="mb-3">
                          <Form.Label>Approver Id</Form.Label>
                          <Form.Select
                            name="approverId"
                            value={this.state.approverId}
                            onChange={this.handleapproverIdChange}
                          >
                            <option value="">Select</option>
                            {this.state.employees
                              .filter(
                                (api) =>
                                  api.dName && api.dName.toUpperCase() === "IT",
                              )
                              .map((api, index) => (
                                <option key={index} value={api.employees_Id}>
                                  {api.fName}&nbsp;{api.lName}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="12">
                        <Form.Group className="mb-3">
                          <Form.Label>Approval Status</Form.Label>
                          <Form.Select
                            className="form-select"
                            onChange={this.handleapprovalStatusChange}
                            name="approvalStatus"
                            value={this.state.approvalStatus}
                            required="required"
                            placeholder="Enter Approval Status"
                          >
                            <option value="">Select</option>
                            <option value="Approved">Approved</option>
                            <option value="Rejected">Rejected</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="12">
                        <Form.Group className="mb-3">
                          <Form.Label>Approval Remarks</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={1}
                            name="approvalRemarks"
                            value={this.state.approvalRemarks}
                            onChange={this.handleapprovalRemarksChange}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col
                        lg="2"
                        md="2"
                        style={{
                          display: "flex",
                          alignItems: "end",
                          paddingBottom: "16px",
                        }}
                      >
                        <Button
                          // className="w-100"
                          style={{
                            backgroundColor: "#16a34a",
                            borderColor: "#16a34a",
                            borderRadius: "8px",
                            fontWeight: 500,
                            padding: "8px 18px",
                            fontSize: "14px",
                          }}
                          onClick={this.DeploymentapprovalssubmitHandler}
                        >
                          Submit
                        </Button>
                      </Col>
                    </Row>
                  </div>
                  )}
                </Form>
              </Tab>

              <Tab eventKey="backend" title="Backend">
                <Form>
                  <div
                    style={{
                      background: "#fafbfc",
                      border: "1px solid #ecf0f5",
                      borderRadius: "10px",
                      padding: "18px 20px",
                      marginBottom: "20px",
                    }}
                  >
                    {this.renderSectionLabel("Project Details")}
                    <Row>
                      <Col lg="3" md="6">
                        <Form.Group className="mb-3">
                          <Form.Label>Environment</Form.Label>
                          <Form.Select
                            name="backendEnvironment"
                            value={this.state.backendEnvironment}
                            onChange={this.handleBackendEnvironmentChange}
                          >
                            <option value="">Select Environment</option>
                            {this.state.environmentmaster.map(
                              (api, index, idx) => (
                                <option key={index} value={api.environmentName}>
                                  {" "}
                                  {api.environmentName}{" "}
                                </option>
                              ),
                            )}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="6">
                        <Form.Group className="mb-3">
                          <Form.Label>Project</Form.Label>
                          <Form.Select
                            name="backendProject"
                            value={this.state.backendProject}
                            onChange={this.handleBackendProjectChange}
                            disabled={!this.state.backendEnvironment}
                          >
                            <option value="">Select Project</option>
                            {this.state.backendFilteredProjects.map(
                              (projName, index) => (
                                <option key={index} value={projName}>
                                  {projName}
                                </option>
                              ),
                            )}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="6">
                        <Form.Group className="mb-3">
                          <Form.Label>User Story</Form.Label>
                          <Form.Select
                            name="backendUserStory"
                            value={this.state.backendUserStory}
                            onChange={this.handleBackendUserStoryChange}
                            disabled={!this.state.backendProject}
                          >
                            <option value="">Select User Story</option>
                            {this.state.userstoriestable
                              .filter(
                                (api) =>
                                  api.projectName === this.state.backendProject,
                              )
                              .map((api, index) => (
                                <option key={index} value={api.userStory}>
                                  {api.userStory}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col
                        lg="3"
                        md="6"
                        style={{
                          display: "flex",
                          alignItems: "end",
                          paddingBottom: "16px",
                          gap: "8px",
                        }}
                      >
                        <Button
                          className="w-100"
                          style={{
                            backgroundColor: "#1f6feb",
                            borderColor: "#1f6feb",
                            borderRadius: "8px",
                            fontWeight: 500,
                            padding: "8px 18px",
                            fontSize: "14px",
                          }}
                          onClick={this.backendFetchHandler}
                          disabled={this.state.backendLoading}
                        >
                          {this.state.backendLoading ? (
                            <>
                              <Spinner
                                animation="border"
                                size="sm"
                                className="me-1"
                              />{" "}
                              Loading...
                            </>
                          ) : (
                            "Fetch"
                          )}
                        </Button>
                        {this.state.backendTree.length > 0 && (
                          <Button
                            variant="outline-secondary"
                            style={{
                              borderRadius: "8px",
                              padding: "8px 12px",
                              fontSize: "14px",
                            }}
                            onClick={this.backendFetchHandler}
                            disabled={this.state.backendLoading}
                            title="Refresh file tree from GitHub"
                          >
                            <i className="bi bi-arrow-clockwise"></i>
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </div>
                  <div
                    style={{
                      background: "#fafbfc",
                      border: "1px solid #ecf0f5",
                      borderRadius: "10px",
                      padding: "18px 20px",
                      marginBottom: "20px",
                    }}
                  >
                    {this.renderSectionLabel("Project Structure")}
                    <Row>
                      {/* Column 1: backend folder tree */}
                      <Col lg="4" md="12">
                        <Form.Group className="mb-3">
                          <Form.Label>Select Files List</Form.Label>
                          {this.state.backendTree.length > 0 && (
                            <Form.Control
                              type="text"
                              size="sm"
                              className="mb-2"
                              placeholder="Search files by name or folder..."
                              value={this.state.backendFileSearch}
                              onChange={(e) =>
                                this.setState({
                                  backendFileSearch: e.target.value,
                                })
                              }
                            />
                          )}
                          <div
                            style={{
                              border: "1px solid #ced4da",
                              borderRadius: "6px",
                              background: "#fff",
                              height: "220px",
                              overflow: "auto",
                              padding: "8px 6px",
                            }}
                          >
                            {this.state.backendLoading ? (
                              <div
                                style={{
                                  textAlign: "center",
                                  paddingTop: "80px",
                                }}
                              >
                                <Spinner animation="border" size="sm" />{" "}
                                <span
                                  style={{ color: "#9aa6b2", fontSize: "13px" }}
                                >
                                  Fetching files from GitHub...
                                </span>
                              </div>
                            ) : this.state.backendTree.length === 0 ? (
                              this.renderCrossTeamOriginalPaths("backend") || (
                                <div
                                  style={{
                                    color: "#9aa6b2",
                                    fontSize: "13px",
                                  }}
                                >
                                  Select a project and click Fetch to load files
                                  from GitHub
                                </div>
                              )
                            ) : (
                              (() => {
                                const term =
                                  this.state.backendFileSearch.trim();
                                const tree = this.getFilteredTree(
                                  this.state.backendFileList,
                                  this.state.backendTree,
                                  term,
                                );
                                if (term && tree.length === 0) {
                                  return (
                                    <div
                                      style={{
                                        color: "#9aa6b2",
                                        fontSize: "13px",
                                      }}
                                    >
                                      No files match "{term}"
                                    </div>
                                  );
                                }
                                return this.renderBackendFileTree(
                                  tree,
                                  0,
                                  !!term,
                                );
                              })()
                            )}
                          </div>
                        </Form.Group>
                        <Row style={{ float: "right" }}>
                          <Col lg="3" md="3">
                            <Button onClick={this.handleBackendMoveFiles}>
                              Move
                            </Button>
                          </Col>
                        </Row>
                      </Col>

                      {/* Column 2: moved files (checkboxes) */}
                      <Col lg="4" md="12">
                        <Form.Group className="mb-3">
                          <Form.Label>Moved Files List</Form.Label>
                          <div
                            style={{
                              border: "1px solid #ced4da",
                              borderRadius: "6px",
                              background: "#fff",
                              height: "220px",
                              overflow: "auto",
                              padding: "8px 10px",
                            }}
                          >
                            {(() => {
                              const moved = (this.state.backendMovedFiles || "")
                                .split(/\r?\n/)
                                .map((l) => l.trim())
                                .filter((l) => l.length > 0);
                              if (moved.length === 0) {
                                return (
                                  <div
                                    style={{
                                      color: "#9aa6b2",
                                      fontSize: "13px",
                                    }}
                                  >
                                    Move files here from the tree
                                  </div>
                                );
                              }
                              return moved.map((path, i) => (
                                <label
                                  key={i}
                                  title={path}
                                  style={{
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 6,
                                    margin: 0,
                                    fontSize: "13px",
                                    lineHeight: "22px",
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={
                                      !!this.state.backendMovedChecked[path]
                                    }
                                    onChange={() =>
                                      this.toggleBackendMovedCheck(path)
                                    }
                                  />
                                  <i
                                    className="bi bi-file-earmark-check"
                                    style={{ color: "#16a34a" }}
                                  />
                                  {path.split("/").pop()}
                                </label>
                              ));
                            })()}
                          </div>
                        </Form.Group>
                        <Row style={{ float: "right" }}>
                          <Col lg="3" md="3">
                            <Button onClick={this.handleBackendDoneFiles}>
                              Done
                            </Button>
                          </Col>
                        </Row>
                      </Col>

                      {/* Column 3: done files */}
                      <Col lg="4" md="12">
                        <Form.Group className="mb-3">
                          <Form.Label>Done Files List</Form.Label>
                          <div
                            style={{
                              border: "1px solid #ced4da",
                              borderRadius: "6px",
                              background: "#fff",
                              height: "220px",
                              overflow: "auto",
                              padding: "8px 10px",
                            }}
                          >
                            {(() => {
                              const done = (this.state.backendDoneFiles || "")
                                .split(/\r?\n/)
                                .map((l) => l.trim())
                                .filter((l) => l.length > 0);
                              if (done.length === 0) {
                                return (
                                  <div
                                    style={{
                                      color: "#9aa6b2",
                                      fontSize: "13px",
                                    }}
                                  >
                                    Completed files will appear here
                                  </div>
                                );
                              }
                              return done.map((path, i) => (
                                <div
                                  key={i}
                                  title={path}
                                  style={{
                                    fontSize: "13px",
                                    lineHeight: "22px",
                                    color: "#16794c",
                                  }}
                                >
                                  <i
                                    className="bi bi-check2-circle"
                                    style={{ marginRight: 6 }}
                                  />
                                  {path.split("/").pop()}
                                </div>
                              ));
                            })()}
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                  <div
                    style={{
                      background: "#fafbfc",
                      border: "1px solid #ecf0f5",
                      borderRadius: "10px",
                      padding: "18px 20px",
                      marginBottom: "20px",
                    }}
                  >
                    {this.renderSectionLabel("Deployment Details")}
                    <Row>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Action Type</Form.Label>
                          <Form.Select
                            type="text"
                            onChange={this.handleBackendactionTypeChange}
                            className="form-control"
                            name="backendactionType"
                            value={this.state.backendactionType}
                            required="required"
                            placeholder="Enter Action Type"
                          >
                            <option defaultValue>Select Action Type</option>
                            {this.state.Deploymentactiontypemaster.map(
                              (api, index, idx) => (
                                <option key={index} value={api.actionType}>
                                  {api.actionType}
                                </option>
                              ),
                            )}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Priority</Form.Label>
                          <Form.Select
                            type="text"
                            onChange={this.handleBackendpriorityChange}
                            className="form-control"
                            name="backendpriority"
                            value={this.state.backendpriority}
                            required="required"
                            placeholder="Enter Priority"
                          >
                            <option defaultValue>Select</option>
                            {this.state.Testcaseprioritymaster.map(
                              (api, index, idx) => (
                                <option key={index} value={api.low}>
                                  {api.low}
                                </option>
                              ),
                            )}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Reason For Deployment</Form.Label>
                          <Form.Control
                            as={"textarea"}
                            rows={2}
                            name="backendreasonForDeployment"
                            value={this.state.backendreasonForDeployment}
                            onChange={
                              this.handleBackendreasonForDeploymentChange
                            }
                            placeholder="Enter reason for deployment"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Status</Form.Label>
                          <Form.Control
                            type="text"
                            onChange={this.handleBackendstatusChange}
                            className="form-control"
                            name="backendstatus"
                            value={this.state.backendstatus}
                            required="required"
                            placeholder="Enter Status"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Deployment Date</Form.Label>
                          <Form.Control
                            type="date"
                            onChange={this.handledeploymentDateChange}
                            className="form-control"
                            name="deploymentDate"
                            value={this.state.deploymentDate}
                            required="required"
                            placeholder="Enter deployment Date"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Deployment Status</Form.Label>
                          <Form.Control
                            type="text"
                            onChange={this.handledeploymentStatusChange}
                            className="form-control"
                            name="deploymentStatus"
                            value={this.state.deploymentStatus}
                            required="required"
                            placeholder="Enter Deployment Status"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6" md="12">
                        <Form.Group className="mb-3">
                          <Form.Label>Files Changes List</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            name="backendFilesChanges"
                            value={this.state.backendFilesChanges}
                            onChange={this.handleBackendFilesChangesChange}
                            placeholder="Enter one file path per line, then click Add"
                          />
                          <div className="d-flex justify-content-end mt-2">
                            <Button
                              size="sm"
                              style={{
                                //backgroundColor: "#fff",
                                //color: "#1f6feb",
                                //border: "1px solid #1f6feb",
                                //borderRadius: "8px",
                                padding: "6px 14px",
                                fontSize: "13px",
                                fontWeight: 500,
                              }}
                              onClick={() =>
                                this.addToList(
                                  "backendFilesChanges",
                                  "backendFilesChangesList",
                                )
                              }
                            >
                              + Add
                            </Button>
                          </div>
                          {this.renderChips(
                            "backendFilesChangesList",
                            this.state.backendFilesChangesList,
                          )}
                        </Form.Group>
                      </Col>
                      <Col lg="6" md="12">
                        <Form.Group className="mb-3">
                          <Form.Label>Assigned Employee</Form.Label>
                          <Form.Select
                            name="backendEmployee"
                            value={this.state.backendEmployee}
                            onChange={this.handleBackendEmployeeChange}
                            disabled
                          >
                            <option value="">Select Employee</option>
                            {this.state.employees
                              .filter(
                                (api) =>
                                  api.dName && api.dName.toUpperCase() === "IT",
                              )
                              .map((api, index) => (
                                <option key={index} value={api.employees_Id}>
                                  {api.fName}&nbsp;{api.lName}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3">
                          <Form.Label>Remarks</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            name="backendRemarks"
                            value={this.state.backendRemarks}
                            onChange={this.handleBackendRemarksChange}
                            placeholder="Add backend remarks"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Version</Form.Label>
                          <Form.Control
                            type="text"
                            name="backendversion"
                            value={this.state.backendversion}
                            onChange={this.handleBackendversionChange}
                            placeholder="Enter version"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Build Number</Form.Label>
                          <Form.Control
                            type="text"
                            name="backendbuildNumber"
                            value={this.state.backendbuildNumber}
                            onChange={this.handleBackendbuildNumberChange}
                            placeholder="Enter build number"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Package Type</Form.Label>
                          <Form.Control
                            type="text"
                            name="backendpackageType"
                            value={this.state.backendpackageType}
                            onChange={this.handleBackendpackageTypeChange}
                            placeholder="Enter package type"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Deployment Packages Status</Form.Label>
                          <Form.Control
                            type="text"
                            name="backenddeploymentPackagesStatus"
                            value={this.state.backenddeploymentPackagesStatus}
                            onChange={
                              this.handleBackenddeploymentPackagesStatusChange
                            }
                            placeholder="Enter deployment packages status"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>

                  <div className="d-flex justify-content-end">
                    <Button
                      style={{
                        backgroundColor: "#16a34a",
                        borderColor: "#16a34a",
                        borderRadius: "8px",
                        padding: "9px 28px",
                        fontWeight: 600,
                        fontSize: "14px",
                      }}
                      onClick={this.handleBackendSubmitClick}
                    >
                      Submit Request
                    </Button>
                  </div>
                  <hr />
                  {this.state.uId == this.state.managerApprover && (
                  <div
                    style={{
                      background: "#fafbfc",
                      border: "1px solid #ecf0f5",
                      borderRadius: "10px",
                      padding: "18px 20px",
                      marginBottom: "20px",
                    }}
                  >
                    {this.renderSectionLabel("Approved Manager")}
                    <Row>
                      <Col lg="3" md="12">
                        <Form.Group className="mb-3">
                          <Form.Label>Approved</Form.Label>
                          <Form.Select
                            name="backendapproverId"
                            value={this.state.backendapproverId}
                            onChange={this.handleBackendapproverIdChange}
                          >
                            <option value="">Select</option>
                            {this.state.employees
                              .filter(
                                (api) =>
                                  api.dName && api.dName.toUpperCase() === "IT",
                              )
                              .map((api, index) => (
                                <option key={index} value={api.employees_Id}>
                                  {api.fName}&nbsp;{api.lName}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="12">
                        <Form.Group className="mb-3">
                          <Form.Label>Approval Status</Form.Label>
                          <Form.Select
                            className="form-select"
                            onChange={this.handleBackendapprovalStatusChange}
                            name="backendapprovalStatus"
                            value={this.state.backendapprovalStatus}
                            required="required"
                            placeholder="Enter Approval Status"
                          >
                            <option value="">Select</option>
                            <option value="Approved">Approved</option>
                            <option value="Rejected">Rejected</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="12">
                        <Form.Group className="mb-3">
                          <Form.Label>Remarks</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={1}
                            name="backendapprovalRemarks"
                            value={this.state.backendapprovalRemarks}
                            onChange={this.handleBackendapprovalRemarksChange}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col
                        lg="2"
                        md="2"
                        style={{
                          display: "flex",
                          alignItems: "end",
                          paddingBottom: "16px",
                        }}
                      >
                        <Button
                          className="w-100"
                          style={{
                            backgroundColor: "#16a34a",
                            borderColor: "#16a34a",
                            borderRadius: "8px",
                            fontWeight: 500,
                            padding: "8px 18px",
                            fontSize: "14px",
                          }}
                          onClick={this.BackendDeploymentapprovalssubmitHandler}
                        >
                          Submit
                        </Button>
                      </Col>
                    </Row>
                  </div>
                  )}
                </Form>
              </Tab>

              <Tab eventKey="tables" title="Tables">
                <Form>
                  <div
                    style={{
                      background: "#fafbfc",
                      border: "1px solid #ecf0f5",
                      borderRadius: "10px",
                      padding: "18px 20px",
                      marginBottom: "20px",
                    }}
                  >
                    {this.renderSectionLabel("Project Details")}
                    <Row>
                      <Col lg="3" md="6">
                        <Form.Group className="mb-3">
                          <Form.Label>Environment</Form.Label>
                          <Form.Select
                            name="tablesEnvironment"
                            value={this.state.tablesEnvironment}
                            onChange={this.handleTablesEnvironmentChange}
                          >
                            <option value="">Select Environment</option>
                            {this.state.environmentmaster.map(
                              (api, index, idx) => (
                                <option key={index} value={api.environmentName}>
                                  {" "}
                                  {api.environmentName}{" "}
                                </option>
                              ),
                            )}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="6">
                        <Form.Group className="mb-3">
                          <Form.Label>Project</Form.Label>
                          <Form.Select
                            name="tablesProject"
                            value={this.state.tablesProject}
                            onChange={this.handleTablesProjectChange}
                            disabled={!this.state.tablesEnvironment}
                          >
                            <option value="">Select Project</option>
                            {this.state.tablesFilteredProjects.map(
                              (projName, index) => (
                                <option key={index} value={projName}>
                                  {projName}
                                </option>
                              ),
                            )}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="6">
                        <Form.Group className="mb-3">
                          <Form.Label>User Story</Form.Label>
                          <Form.Select
                            name="tablesUserStory"
                            value={this.state.tablesUserStory}
                            onChange={this.handleTablesUserStoryChange}
                            disabled={!this.state.tablesProject}
                          >
                            <option value="">Select User Story</option>
                            {this.state.userstoriestable
                              .filter(
                                (api) =>
                                  api.projectName === this.state.tablesProject,
                              )
                              .map((api, index) => (
                                <option key={index} value={api.userStory}>
                                  {api.userStory}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col
                        lg="3"
                        md="6"
                        style={{
                          display: "flex",
                          alignItems: "end",
                          paddingBottom: "16px",
                        }}
                      >
                        <Button
                          className="w-100"
                          style={{
                            backgroundColor: "#1f6feb",
                            borderColor: "#1f6feb",
                            borderRadius: "8px",
                            fontWeight: 500,
                            padding: "8px 18px",
                            fontSize: "14px",
                          }}
                          onClick={this.tablesFetchHandler}
                        >
                          Fetch
                        </Button>
                      </Col>
                    </Row>
                  </div>
                  <div
                    style={{
                      background: "#fafbfc",
                      border: "1px solid #ecf0f5",
                      borderRadius: "10px",
                      padding: "18px 20px",
                      marginBottom: "20px",
                    }}
                  >
                    {this.renderSectionLabel("Project Structure")}
                    <Row>
                      <Col lg="4" md="12">
                        <Row>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label>Select Files List</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={8}
                                name="tablesNpmPackages"
                                value={this.state.tablesNpmPackages}
                                onChange={this.handleTablesNpmPackagesChange}
                                placeholder="Enter file paths to deploy"
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row style={{ float: "right" }}>
                          <Col lg="3" md="3">
                            <Button>Move</Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg="4" md="12">
                        <Row>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label>Moved Files List</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={8}
                                name="tablesNpmPackages"
                                value={this.state.tablesNpmPackages}
                                onChange={this.handleTablesNpmPackagesChange}
                                placeholder="Enter moved file paths"
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row style={{ float: "right" }}>
                          <Col lg="3" md="3">
                            <Button>Done</Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg="4" md="12">
                        <Form.Group className="mb-3">
                          <Form.Label>Done Files List</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={8}
                            name="tablesNpmPackages"
                            value={this.state.tablesNpmPackages}
                            onChange={this.handleTablesNpmPackagesChange}
                            placeholder="Enter completed file paths"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                  <div
                    style={{
                      background: "#fafbfc",
                      border: "1px solid #ecf0f5",
                      borderRadius: "10px",
                      padding: "18px 20px",
                      marginBottom: "20px",
                    }}
                  >
                    {this.renderSectionLabel("Deployment Details")}
                    <Row>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Action Type</Form.Label>
                          <Form.Select
                            type="text"
                            onChange={this.handletablesactionTypeChange}
                            className="form-control"
                            name="tablesactionType"
                            value={this.state.tablesactionType}
                            required="required"
                            placeholder="Enter Action Type"
                          >
                            <option defaultValue>Select Action Type</option>
                            {this.state.Deploymentactiontypemaster.map(
                              (api, index, idx) => (
                                <option key={index} value={api.actionType}>
                                  {api.actionType}
                                </option>
                              ),
                            )}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Priority</Form.Label>
                          <Form.Select
                            type="text"
                            onChange={this.handletablespriorityChange}
                            className="form-control"
                            name="tablespriority"
                            value={this.state.tablespriority}
                            required="required"
                            placeholder="Enter Priority"
                          >
                            <option defaultValue>Select</option>
                            {this.state.Testcaseprioritymaster.map(
                              (api, index, idx) => (
                                <option key={index} value={api.low}>
                                  {api.low}
                                </option>
                              ),
                            )}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Reason For Deployment</Form.Label>
                          <Form.Control
                            as={"textarea"}
                            rows={2}
                            name="tablesreasonForDeployment"
                            value={this.state.tablesreasonForDeployment}
                            onChange={
                              this.handletablesreasonForDeploymentChange
                            }
                            placeholder="Enter reason for deployment"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Status</Form.Label>
                          <Form.Control
                            type="text"
                            onChange={this.handletablesstatusChange}
                            className="form-control"
                            name="tablesstatus"
                            value={this.state.tablesstatus}
                            required="required"
                            placeholder="Enter Status"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Assigned Employee</Form.Label>
                          <Form.Select
                            name="tablesassignedTo"
                            value={this.state.tablesassignedTo}
                            onChange={this.handletablesassignedToChange}
                            disabled
                          >
                            <option value="">Select Employee</option>
                            {this.state.employees
                              .filter(
                                (api) =>
                                  api.dName && api.dName.toUpperCase() === "IT",
                              )
                              .map((api, index) => (
                                <option key={index} value={api.employees_Id}>
                                  {api.fName}&nbsp;{api.lName}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Deployment Date</Form.Label>
                          <Form.Control
                            type="date"
                            onChange={this.handletablesdeploymentDateChange}
                            className="form-control"
                            name="tablesdeploymentDate"
                            value={this.state.tablesdeploymentDate}
                            required="required"
                            placeholder="Enter deployment Date"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Deployment Status</Form.Label>
                          <Form.Control
                            type="text"
                            onChange={this.handletablesdeploymentStatusChange}
                            className="form-control"
                            name="tablesdeploymentStatus"
                            value={this.state.tablesdeploymentStatus}
                            required="required"
                            placeholder="Enter Deployment Status"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Remarks</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            name="tablesremarks"
                            value={this.state.tablesremarks}
                            onChange={this.handletablesremarksChange}
                            placeholder="Add frontend remarks"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Version</Form.Label>
                          <Form.Control
                            type="text"
                            name="tablesversion"
                            value={this.state.tablesversion}
                            onChange={this.handleTablesversionChange}
                            placeholder="Enter version"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Package Type</Form.Label>
                          <Form.Control
                            type="text"
                            name="tablespackageType"
                            value={this.state.tablespackageType}
                            onChange={this.handleTablespackageTypeChange}
                            placeholder="Enter package type"
                          />
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="3">
                        <Form.Group className="mb-3">
                          <Form.Label>Deployment Packages Status</Form.Label>
                          <Form.Control
                            type="text"
                            name="tablesdeploymentPackagesStatus"
                            value={this.state.tablesdeploymentPackagesStatus}
                            onChange={
                              this.handleTablesdeploymentPackagesStatusChange
                            }
                            placeholder="Enter deployment packages status"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                  <div className="d-flex justify-content-end">
                    <Button
                      style={{
                        backgroundColor: "#16a34a",
                        borderColor: "#16a34a",
                        borderRadius: "8px",
                        padding: "9px 28px",
                        fontWeight: 600,
                        fontSize: "14px",
                      }}
                      onClick={this.handletablesSubmitClick}
                    >
                      Submit Request
                    </Button>
                  </div>
                  <hr />
                  <div
                    style={{
                      background: "#fafbfc",
                      border: "1px solid #ecf0f5",
                      borderRadius: "10px",
                      padding: "18px 20px",
                      marginBottom: "20px",
                    }}
                  >
                    {this.renderSectionLabel("Approval & Notes")}
                    <Row>
                      <Col lg="3" md="12">
                        <Form.Group className="mb-3">
                          <Form.Label>Assigned Employee</Form.Label>
                          <Form.Select
                            name="tablesEmployee"
                            value={this.state.tablesEmployee}
                            onChange={this.handleTablesEmployeeChange}
                          >
                            <option value="">Select Employee</option>
                            {this.state.employees
                              .filter(
                                (api) =>
                                  api.dName && api.dName.toUpperCase() === "IT",
                              )
                              .map((api, index) => (
                                <option key={index} value={api.employees_Id}>
                                  {api.fName}&nbsp;{api.lName}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="12">
                        <Form.Group className="mb-3">
                          <Form.Label>Approval Status</Form.Label>
                          <Form.Select
                            className="form-select"
                            onChange={this.handleTablesStatusapprovalChange}
                            name="tablesapprovalStatus"
                            value={this.state.tablesapprovalStatus}
                            required="required"
                            placeholder="Enter Approval Status"
                          >
                            <option value="">Select</option>
                            <option value="Approved">Approved</option>
                            <option value="Rejected">Rejected</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg="3" md="12">
                        <Form.Group className="mb-3">
                          <Form.Label>Approval Remarks</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            name="tablesRemarks"
                            value={this.state.tablesRemarks}
                            onChange={this.handleTablesRemarksChange}
                            placeholder="Add table remarks"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                  <div className="d-flex justify-content-end">
                    <Button
                      style={{
                        backgroundColor: "#16a34a",
                        borderColor: "#16a34a",
                        borderRadius: "8px",
                        padding: "9px 28px",
                        fontWeight: 600,
                        fontSize: "14px",
                      }}
                      onClick={this.tablesApprovalSubmitHandler}
                    >
                      Submit
                    </Button>
                  </div>
                </Form>
              </Tab>
            </Tabs>
          </Card.Body>
        </Card>

        {/* Cross-Team Check Modal */}
        <CrossTeamCheck
          show={this.state.showCrossTeamModal}
          onClose={() => this.setState({ showCrossTeamModal: false })}
          onConfirm={this.handleCrossTeamConfirm}
          requestType={this.state.crossTeamRequestType}
        />
      </div>
    );
  }
}

// Wrapper to inject react-router v6 location (state passed from "Raise Changes")
// into the class component via props.
export default function DeploymentRequestpageWithRouter(props) {
  const location = useLocation();
  return <DeploymentRequestpage {...props} location={location} />;
}
